<template>
  <div>
    <section class=dims-m>
      <p class="cta"><strong>COMPARE MODEL DIMENSIONS</strong></p>
      <div class="dims-m-container">
        <div class="dims-m-nav">
          <span class="prev" :class="{active : colCounter > 1}" @click="goPrev()"></span>
            <ul>
              <li :class="{selected : colCounter == 1}"></li>
              <li :class="{selected : colCounter == 2}"></li>
              <li :class="{selected : colCounter == 3}"></li>
              <li :class="{selected : colCounter == 4}"></li>
              <li :class="{selected : colCounter == 5}"></li>
            </ul>
          <span class="next" :class="{active : colCounter < 5}" @click="goNext()"></span>
        </div>
        <div class="chart">
          <ul class="col1">
            <li>Reformer</li>
            <li>JGRIMES Contrology 80”</li>
            <li>Contrology 80”</li>
            <li>Contrology 86”</li>
            <li>Contrology 89”</li>
          </ul>
          <ul v-show="colCounter == 1" class="col">
            <li>Reformer Length</li>
            <li>81”/206cm</li>
            <li>81”/206cm</li>
            <li>87”/221cm</li>
            <li>90”/229cm</li>
          </ul>
          <ul v-show="colCounter == 2" class="col">
            <li>Frame Width</li>
            <li>27”/69cm</li>
            <li>27”/69cm</li>
            <li>27”/69cm</li>
            <li>27”/69cm</li>
          </ul>
          <ul v-show="colCounter == 3" class="col">
            <li>Frame Height</li>
            <li>14”/36cm</li>
            <li>14”/36cm</li>
            <li>14”/36cm</li>
            <li>14”/36cm</li>
          </ul>
          <ul v-show="colCounter == 4" class="col">
            <li>Reformer Weight</li>
            <li>114lbs/51.7kg</li>
            <li>114lbs/51.7kg</li>
            <li>117lbs/53kg</li>
            <li>118.5lbs/53.8kg</li>
          </ul>
          <ul v-show="colCounter == 5" class="col">
            <li>Carriage Dimensions</li>
            <li>22"/56cm by 36”/91cm</li>
            <li>22"/56cm by 36”/91cm</li>
            <li>22"/56cm by 36”/91cm</li>
            <li>22"/56cm by 36”/91cm</li>
          </ul>
        </div>
      </div>
      <span style="display:inline-block;margin-top:5px;"><em>*JGRIMES Reformer offers no customization or accessory options.</em></span>
    </section>
    <section class="dims show-large">
      <p class="cta"><strong>COMPARE MODEL DIMENSIONS</strong></p>
      <table>
        <thead>
          <tr>
            <th>Reformer</th>
            <th>Frame Length</th>
            <th>Frame Width</th>
            <th>Frame Height</th>
            <th>Reformer<br>Weight</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>JGRIMES Contrology 80&rdquo;</td>
            <td>80”/203cm</td>
            <td>27”/69cm</td>
            <td>14”/36cm</td>
            <td>114lbs/51.7kg</td>
          </tr>
          <tr>
            <td>Contrology 80&rdquo;</td>
            <td>80”/203cm</td>
            <td>27”/69cm</td>
            <td>14”/36cm</td>
            <td>114lbs/51.7kg</td>
          </tr>
          <tr>
            <td>Contrology 86&rdquo;</td>
            <td>86”/218cm</td>
            <td>27”/69cm</td>
            <td>14”/36cm</td>
            <td>117lbs/53kg</td>
          </tr>
          <tr>
            <td>Contrology 89&rdquo;</td>
            <td>89”/226cm</td>
            <td>27”/69cm</td>
            <td>14”/36cm</td>
            <td>117lbs/53kg</td>
          </tr>
        </tbody>
      </table>
      <span style="display:inline-block;margin-top:5px;"><em>*JGRIMES Reformer offers no customization or accessory options.</em></span>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'dimensionstable',

    data() {
      return {
        colCounter: 1
      }
    },

    methods: {
      goPrev() {
        if (this.colCounter !== 1) {
          this.colCounter--;
        }
      },

      goNext() {
        if (this.colCounter !== 5) {
          this.colCounter++;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.show-large {
  display: none;
}

.dims {
  margin-top: 30px;
}

.dims table {
  border-collapse: collapse;
  font-family: var(--roboto);
  line-height: 1.25;
  color: #000;
  font-size: .75em;
  margin: 13px auto 0;
}

.dims th, .dims td {
  text-align: left;
  width: 20%;
  padding: 5px 10px;
  border: 1px solid #c4c4c4;
}

.dims td {
  height: 50px;
}

.dims tr th:first-of-type, .dims tr td:first-of-type {
  background-color: rgba(255, 255, 255, 0.5)
}

.dims-m {
  margin-bottom: 40px;
}

.dims-m-nav {
  width: 90%;
  height: 24px;
  border: 1px solid #c4c4c4;
  background-color: rgba(255, 255, 255, 0.5);
  margin: 26px auto 6px;
  position: relative;
}

.dims-m-nav ul {
  list-style: none;
  text-align: center;
  padding: 0;
  margin: 0;
  line-height: .75;
}

.dims-m-nav ul li::before {
  content: "\2022";
  color: #969696;
  font-size: 2em;
  font-weight: bold;
}

.dims-m-nav ul li {
  display: inline;
  padding: 15px;
}

.dims-m-nav ul li.selected::before {
  color: #000;
}

.prev, .next {
  height: 36px;
  width: 36px;
  background-color: #969696;
  border-radius: 50%;
  display: inline-block;
  position: absolute;
  top: -8px;
}

.prev {
  left: -20px;
}

.prev::after {
  content: "";
  border-right: 3px solid var(--white);
  border-bottom: 3px solid var(--white);
  height: 16px;
  width: 16px;
  transform: rotate(135deg);
  display: block;
  position: absolute;
  top: 10px;
  right: 6px;
}

.next {
  right: -20px;
}

.next::after {
  content: "";
  border-right: 3px solid var(--white);
  border-bottom: 3px solid var(--white);
  height: 16px;
  width: 16px;
  transform: rotate(-45deg);
  display: block;
  position: absolute;
  top: 10px;
  left: 6px;
}

.active {
  background-color: #000;
}

.chart {
  font-family: var(--roboto);
  margin-top: -8px;
}

.col1 {
  background-color: rgba(255, 255, 255, 0.5);
  width: 50%;
  border-left: 1px solid #c4c4c4;
}

.col {
  width: 50%;
  float: right;
}

.chart ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: inline-block;
}

.chart ul li:first-of-type {
  font-weight: 700;
}

.chart ul li {
  padding: 15px 10px;
  border-bottom: 1px solid #c4c4c4;
  border-right: 1px solid #c4c4c4;
  height: 60px;
  display: flex;
  align-items: center;
}
</style>
